<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-sm-12">
          <div class="element-wrapper">
            <div class="element-box">
              <form id="formValidate">
                <div class="element-info">
                  <div class="element-info-with-icon">
                    <div class="element-info-text">
                      <h5 class="element-inner-header">
                        Solicitud de Mtto
                      </h5>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <ActivoFijoSelectComponent
                    :current="current"
                    :disabled="current.id != null"
                  />
                </div>
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger':
                        errors.nombre && errors.encargado.length > 0,
                    }"
                    >Encargado</label
                  >
                  <input
                    v-model="current.encargado"
                    class="form-control"
                    autofocus="autofocus"
                    placeholder="Encargado"
                    type="text"
                    v-bind:class="{
                      'is-invalid':
                        errors.encargado && errors.encargado.length > 0,
                    }"
                  />
                  <small
                    v-if="errors.encargado && errors.encargado"
                    class="form-text text-danger"
                    >{{ errors.encargado[0] }}</small
                  >
                </div>
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger': errors.estado && errors.tipo.length > 0,
                    }"
                    >Tipo</label
                  >
                  <select
                    class="form-control"
                    v-model="current.tipo"
                    placeholder="Tipo"
                    type="text"
                    v-bind:class="{
                      'is-invalid': errors.tipo && errors.tipo.length > 0,
                    }"
                  >
                    <option value="S">Servicio</option>
                    <option value="C">Combustible</option>
                    <option value="M">Mantenimiento</option>
                    <option value="R">Reparacion</option>
                  </select>
                  <small
                    v-if="errors.tipo && errors.tipo"
                    class="form-text text-danger"
                    >{{ errors.tipo[0] }}</small
                  >
                </div>
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger':
                        errors.descripcion && errors.descripcion.length > 0,
                    }"
                    >Descripción</label
                  >
                  <textarea
                    class="form-control"
                    rows="3"
                    v-model="current.descripcion"
                    autofocus="autofocus"
                    placeholder="Descripción"
                    v-bind:class="{
                      'is-invalid':
                        errors.descripcion && errors.descripcion.length > 0,
                    }"
                  >
                  </textarea>
                  <small
                    v-if="errors.descripcion && errors.descripcion"
                    class="form-text text-danger"
                    >{{ errors.descripcion[0] }}</small
                  >
                </div>
                <div class="row">
                  <div class="col-4">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            errors.fecha &&
                            errors.fecha.length > 0,
                        }"
                        >Fecha a Realizar</label
                      >
                      <input
                        v-model="current.fecha"
                        class="form-control"
                        placeholder="Fecha de Compra"
                        type="text"
                        v-bind:class="{
                          'is-invalid':
                            errors.fecha &&
                            errors.fecha.length > 0,
                        }"
                      />
                      <small
                        v-if="errors.fecha && errors.fecha"
                        class="form-text text-danger"
                        >{{ errors.fecha[0] }}</small
                      >
                    </div>
                  </div>
                </div>

                <div class="form-buttons-w">
                  <button
                    class="btn btn-primary"
                    type="button"
                    @click="guardar"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import PaginationComponent from "@/components/utils/PaginationComponent";
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";
import ActivoFijoSelectComponent from "@/components/commons/ActivoFijoSelectComponent";

export default {
  components: {
    ActivoFijoSelectComponent,
  },
  data() {
    return {
      file: "",
      current: {},
      errors: {
        id: null,
        identificador: null,
        nombre: null,
        descripcion: null,
        fecha_creacion: null,
        fecha_compra: null,
        precio_compra: null,
        no_fact_compra: null,
        vida_util: null,
        marca: null,
        color: null,
        modelo: null,
        no_serie: null,
        placa: null,
        tipo_vehiculo: null,
        estado: null,
        imagen: null,
        grupo: null,
      },
      data: [],
      grupos: [],
    };
  },

  computed: {},
  mounted() {
    let self = this;
    if (this.$route.params.id) {
      self.refreshData();
    }
  },

  methods: {
    guardar() {
      let self = this;

      let current = Object.assign({}, self.current);
      current.activo = self.current.activo.id;
      DynamicService.save("af", "solicitud-mtto", current)
        .then((res) => {
          self.current.pk = res.data.id;
          self.current.id = res.data.id;
          Notifications.alert.success(
            "Activo Fijo",
            "Se ha guardado la Información."
          );
          self.$router.push({
            name: "af-solicitud-mtto-editar",
            params: { id: self.current.id },
          });
          self.refreshData();
        })
        .catch((error) => {
          console.log(error);
          self.current.errors = Object.assign(self.current.errors, error.response.data);
          console.log(self.errors);
          if ("detail" in error.response.data) {
            Notifications.alert.error("Error", error.response.data.detail);
          }
        });
    },

    refreshData() {
      let self = this;
      DynamicService.getById(
        "af",
        "solicitud-mtto",
        this.$route.params.id
      ).then((response) => {
        self.current = response.data;
        self.current.activo = self.current.activo_obj;
        self.current.pk = self.current.id;
        for (var key in self.current) {
          self.errors[key] = [];
        }
      });
    },
  },
};
</script>
